import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import { withTranslation, WithTranslation } from 'react-i18next';

interface ISubtypeDropDownProps extends WithTranslation{
    handleChanges: any;
    error: any
    value: string
}

const SubtypeDropDown =(props: ISubtypeDropDownProps) =>{
    const selectOptions = [
        { key: "strength", text: props.t('subtype.strength'), value: "strength" },
        { key: "endurance", text: props.t('subtype.endurance'), value: "endurance" },
        { key: "resistance", text: props.t('subtype.resistance'), value: "resistance" }
    ];
    return(<Dropdown
        placeholder={props.t('placeholder.subtype')}
        fluid
        selection
        options={selectOptions}
        onChange={props.handleChanges}
        id='workoutSubtype'
        error= {props.error}
        value = {props.value}
  />)
}

export default withTranslation('exerciseCreator') (SubtypeDropDown);